import React from 'react';
import NudeNewsContactPage from './NudeNewsContactUs';
import { isNudeDomain } from '../../utils/helpers';
import validator from 'validator';
import callApi from '../../utils/callApi';
import { CATEGORIES_URL, CONTACT_FORM_SUBMIT } from '../../constants/apiUrls/apiUrls';

class ContactUs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: { value: '', isValid: true },
            email: { value: '', isValid: true },
            category: { value: '', isValid: true },
            description: { value: '', isValid: true },
            categoriesList: [],
            showForm: true,
            isButtonDisabled: false,
            message: ''
        }
    }

    componentDidMount = () => {
      callApi(CATEGORIES_URL, 'get', {})
      .then(res => this.setState({categoriesList: res.data}))
    }
    

    handleChange = e => {
        const { name, value } = e.target;
        const isValid = !validator.isEmpty(value);

        this.setState({
            [name]: {value, isValid}
        })
    }

    handleEmail = e => {
        const { value } = e.target;
        const isValid = !validator.isEmpty(value) && validator.isEmail(value);

        this.setState({
            email: {value, isValid}
        })
    }

    validateForm = () => {
      const { name, email, category, description } = this.state;
      let formIsValid = true;

      if (validator.isEmpty(name.value) || !name.isValid) {
        formIsValid = false;
        this.setState(prevState => ({ name: {value: prevState.name.value, isValid: false} }))
      }

      if (validator.isEmpty(email.value) || !email.isValid) {
        formIsValid = false;
        this.setState(prevState => ({ email: {value: prevState.email.value, isValid: false} }))
      }

      if (validator.isEmpty(category.value) || !category.isValid) {
        formIsValid = false;
        this.setState(prevState => ({ category: {value: prevState.category.value, isValid: false} }))
      }

      if (validator.isEmpty(description.value) || !description.isValid) {
        formIsValid = false;
        this.setState(prevState => ({ description: {value: prevState.description.value, isValid: false} }))
      }

      return formIsValid;

    }

    handleFormSubmit = () => {
        const { name, email, category, description } = this.state;
        const fields = {
            name: name.value,
            email: email.value,
            category: category.value,
            description: description.value
        }

        if (this.validateForm()) {
          this.setState({isButtonDisabled: true});

          callApi(CONTACT_FORM_SUBMIT, 'post', {}, fields)
              .then(res => {
                  if (res.status === 200) {
                      this.setState({
                          showForm: false,
                          message: 'Thank you for contacting us!'
                      })
                  } else {
                      this.setState({
                          showForm: false,
                          message: 'There was a problem with your submission, please try again.'
                      })
                  }
              })
        }
        
    }

    render() {
        const { name, email, category, description, categoriesList, showForm, message, isButtonDisabled } = this.state;

        if (isNudeDomain) {
            return <NudeNewsContactPage />;
        }
        return (
            <div className="content">
                <div className="container">
                    <div className="content-card1">
                        <h1>Contact Naked News</h1>
                        <p className="lead">
                            <strong>
                                Experiencing access issues? Our customer service team is here
                                to assist you!
                            </strong>
                        </p>

                        <p>
                            <strong>Note:</strong> For technical, membership,
                            and all other site related issues you can email us{' '}
                            <a href="mailto:support@nakednews.com">
                                support@nakednews.com
                            </a>
                            . But, before you do so, please visit our{' '}
                            <a href="/faq">FAQ page</a>. We have listed and have
                            provided answers to some of the most common issues
                            our customers encounter.
                        </p>
                        <div className="well-contact">
                            <p>
                                The Naked News Support Department responds to
                                ALL requests for help. However, some Internet
                                Service Providers (ISPs) such as AOL and
                                RoadRunner, as well as some email sites, may
                                block or divert our replies to you because the
                                word "Naked" sets off their spam detector
                                programs.
                            </p>
                            <p>
                                If you do not get a timely reply to your
                                question, please check your email program's
                                spambox, trash box, and anywhere else it might
                                have been diverted. You may also want to contact
                                your ISP's email administrator and request that
                                they make sure that our email is allowed to get
                                to you.{' '}
                            </p>

                            <div>
                                <p>
                                    We do not spam our members or anyone else, and
                                    some Naked News fans have missed important
                                    Support messages because of these actions.{' '}
                                </p>
                            </div>
                        </div>
                        <p className="lead">
                            <strong>
                                Help us improve Naked News. We would love to
                                hear from you
                            </strong>
                        </p>
                        <div>
                            <p>
                                We are always working to make Naked News exactly
                                what you need. Your feedback helps us decide
                                which features to build and what improvements
                                should be made to our platform. To help us make
                                Naked News the best it can be, we would need
                                your help. Please take a few moments to tell us
                                about your experience on Naked News simply by
                                sending us an email at{' '}
                                <a href="mailto:feedback@nakednews.com">
                                    feedback@nakednews.com
                                </a>{' '}
                                or by filling up the fields below.
                            </p>
                        </div>
                    </div>

                    {showForm &&
                        <div className="form-horizontal mb-40">
                        <div className="form-group" style={{marginBottom: !name.isValid && '30px'}}>
                            <label htmlFor="name">Name</label>
                            <input
                                type="text"
                                className="form-control"
                                name="name"
                                value={name.value}
                                onChange={this.handleChange}
                                ref={name => this._name}
                            />
                            {!name.isValid &&
                                <div className="errorText">This field is required.</div>
                            }
                        </div>
                        <div className="form-group" style={{marginBottom: !email.isValid && '30px'}}>
                            <label htmlFor="email">Email</label>
                            <input
                                type="text"
                                className="form-control"
                                name="email"
                                value={email.value}
                                onChange={this.handleEmail}
                            />
                            {!email.isValid &&
                                <div className="errorText">Email must be valid.</div>
                            }
                        </div>
                        <div className="form-group"  style={{marginBottom: !category.isValid && '30px'}}>
                            <label htmlFor="category">Category</label>
                            <select className="form-control capitalize" value={category.value} name="category" onChange={this.handleChange}>
                              <option defaultValue value='' disabled>Select</option>
                                {categoriesList && categoriesList.map((cat, index) => (
                                    <option key={index} value={cat} className="capitalize" >{cat.replace('_', ' ').toLowerCase()}</option>
                                ))
                                }
                            </select>
                            {!category.isValid &&
                                <div className="errorText">This field is required.</div>
                            }
                        </div>
                        <div className="form-group" style={{marginBottom: !description.isValid && '30px'}}>
                            <label htmlFor="description">Description</label>
                            <textarea
                                rows="5"
                                className="form-control"
                                name="description"
                                value={description.value}
                                onChange={this.handleChange}
                            />
                            {!description.isValid &&
                                <div className="errorText">This field is required.</div>
                            }
                        </div>
                        <button className="btn btn-red btn-lg" type="button" onClick={this.handleFormSubmit} disabled={isButtonDisabled}>Submit</button>
                    </div>
                    }

                    {!showForm &&
                        <div className="contact-message">{message}</div>
                    }

                </div>
            </div>
        );
    }
}
export default ContactUs;
